module.exports = __webpack_public_path__ + "img/business-finance.5fabc2dc.svg";